import type { Campus } from '@/api';

export const useCampusPolicy = (app: Ref<Campus | undefined>) => {
    const { isSchool, isAgency, authorized_branches, permissions } = useCompany();
    const getPolicy = (campus: Campus | undefined) => {
        const isAuthorized = authorized_branches.value?.some(ab => ab.id === campus?.company_branch_id);

        const update = (isSchool && isAuthorized && permissions.value.editCampuses) || campus?.can?.update;

        const addProgramToCampus = isSchool && isAuthorized && permissions.value.editCampuses;
        const removeProgramFromCampus = isSchool && isAuthorized && permissions.value.editCampuses;
        const addPackageToCampus = isSchool && isAuthorized && permissions.value.editCampuses;
        const removePackageFromCampus = isSchool && isAuthorized && permissions.value.editCampuses;
        return {
            update,
            addProgramToCampus,
            removeProgramFromCampus,
            addPackageToCampus,
            removePackageFromCampus,
        } as const;
    };

    const policy = computed(() => getPolicy(app.value));

    return { policy, getPolicy };
};
